// Chakra imports
import { Flex, FormControl, Text, useColorModeValue } from '@chakra-ui/react';
import Card from '../../../../../../components/card/Card';
import CustomButton from '../../../../../../components/Common/CustomButton';
import CustomPasswordInput from '../../../../../../components/Common/CustomInput/CustomPasswordInput';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectButtonLoading, selectPasswordForm } from '../../../../../../views/auth/selector';
import { actions } from '../../../../../../views/auth/slice';
import { useTranslation } from 'react-i18next';

export default function Password(props: { [x: string]: any }) {
  const { ...rest } = props;
  const {t} = useTranslation()
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'secondaryGray.600';
  // Chakra Color Mode
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectPasswordForm);
  const loading = useSelector(selectButtonLoading);

  const handleFieldChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    dispatch(actions.updatePasswordFormValue({ key: name, value: value }));
  };
  const handleSubmit = () => {
    dispatch(
      actions.doUpdatePassword({
        callback(token) {
          dispatch(actions.clearPasswordFrom());
          dispatch(actions.doGetProfile({ token: token, callback() {} }));
          navigate('/admin/dashboards');
        },
      }),
    );
  };
  return (
    <Card {...rest}>
      <Flex direction="column" mb="30px" ms="10px">
        <Text fontSize="xl" color={textColorPrimary} fontWeight="bold">
          Change password
          {t("login.updatePassword.changePassword")}
          
        </Text>
        <Text fontSize="md" color={textColorSecondary}>
         {t("login.updatePassword.headingText")}
        </Text>
      </Flex>
      <FormControl>
        <Flex flexDirection="column">
          <CustomPasswordInput
            name={'password'}
            value={form.password}
            handleChange={handleFieldChange}
            placeholder={t("login.updatePassword.changePassword")}
            title={t("login.updatePassword.changePassword")}
          />
          <CustomPasswordInput
            name={'confirmPassword'}
            value={form.confirmPassword}
            handleChange={handleFieldChange}
           placeholder={t("login.updatePassword.changePassword")}
          title={t("login.updatePassword.changePassword")}
          />
          <Flex w={200} ms="auto">
            <CustomButton
              handleClick={handleSubmit}
              title={t("login.updatePassword.changePassword")}
              loading={loading}
            />
          </Flex>
        </Flex>
      </FormControl>
    </Card>
  );
}
